import React from "react";
import { ArrowRightIcon } from "lucide-react";
type CTAButtonProps = {
  children: React.ReactNode;
  className?: string;
  tone?: "green" | "blue";
  shimmer?: boolean;
  pulse?: boolean;
  href?: string;
};
export function CTAButton({
  children,
  className = "",
  tone = "green",
  shimmer = false,
  pulse = false,
  href = "#incluye"
}: CTAButtonProps) {
  const colorClasses = tone === "blue" ? "bg-[#0077e8] shadow-[0_8px_20px_rgba(0,119,232,0.20)] hover:bg-[#0065c5] hover:shadow-[0_12px_24px_rgba(0,119,232,0.26)] focus-visible:outline-[#0077e8]" : "bg-[#07966b] shadow-[0_8px_20px_rgba(7,150,107,0.18)] hover:bg-[#067c5a] hover:shadow-[0_12px_24px_rgba(7,150,107,0.24)] focus-visible:outline-[#07966b]";
  return <a href={href} data-sticky-cta className={`group relative isolate inline-flex w-full items-center justify-center gap-2 overflow-hidden rounded-xl px-5 py-4 text-center text-sm font-extrabold tracking-[0.015em] text-white transition-[background-color,transform,box-shadow] duration-200 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 sm:w-auto ${colorClasses} ${className}`} data-id="element-42" data-mp="2yre2p70nlu4l">
      {shimmer && <span aria-hidden="true" className="cta-shimmer pointer-events-none absolute inset-y-[-40%] left-[-30%] w-[18%] -skew-x-12 bg-white/25 motion-reduce:animate-none" data-id="element-43" data-mp="1i9kxi0rcfcfw" />}
      <span className={`relative z-10 inline-flex items-center gap-2 ${pulse ? "cta-pulse-content" : ""}`} data-id="element-44" data-mp="1n9z3zedaqebt">
        <span data-id="element-45" data-mp="1s5o71roiydcv">{children}</span>
        <ArrowRightIcon className={`h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5 ${pulse ? "cta-arrow-nudge" : ""}`} aria-hidden="true" data-id="element-46" data-mp="1w8ucix3tc0ia" />
      </span>
    </a>;
}